<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <h2 class="accessibility-only">Member Card</h2>
  <div
    class="member-card bg-primary text-white rounded"
    [ngClass]="{
      'navbar-padding': isNav,
    }"
  >
    <div class="member-card-details" [ngClass]="{ 'mb-0': isKid }">
      <!--Name and ID-->
      <div class="card-id text-start d-flex">
        <h5 class="mb-0 card-name text-capitalize" *ngIf="memberDetails$ | async as memberDetails">
          {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
        </h5>
        <div class="d-flex font-size-14">
          <div>{{ memberCard.ExternalRefNumber }} - {{ 'member.card.id' | translate }}</div>
        </div>
      </div>

      <ng-container *ngIf="cardToken$ | async as cardToken">
        <ng-container *ngIf="cardToken.CardIssuer !== 'CHASE'">
          <ng-container *ngIf="showLogo">
            <img
              *notInPopulation="[population.Kids]"
              class="logo"
              [height]="48"
              [width]="48"
              [src]="'logos/nav-logo.svg' | contentAssetImage"
              alt=""
              draggable="false"
            />
            <img
              *inPopulation="[population.Kids]"
              class="logo"
              [height]="60"
              [width]="60"
              [src]="'logos/kids-logo.png' | contentAssetImage"
              alt=""
              draggable="false"
            />
          </ng-container>
        </ng-container>

        <img
          class="ms-2 chase-logo"
          *ngIf="cardToken.CardIssuer == 'CHASE'"
          [height]="12"
          [src]="'logos/chase-white-logo.png' | contentAssetImage"
          alt=""
          draggable="false"
        />
      </ng-container>
    </div>

    <!--Balances-->
    <div class="w-100" *ngIf="showBalanceWidgets">
      <fgb-balance-widgets></fgb-balance-widgets>
    </div>

    <!--Direct Auth-->
    <ng-container *notInPopulation="[population.Kids]">
      <div class="w-100">
        <fgb-ecash-button [isNav]="isNav"></fgb-ecash-button>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
